"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Failed(_ref) {
  var isOverBalance = _ref.isOverBalance,
      commonErrors = _ref.commonErrors;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary']
    }, isOverBalance && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-headline']
    }, "\u0421\u0443\u043C\u043C\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441"), commonErrors.map(function (_ref2, index) {
      var message = _ref2.message;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        className: _defaultModule["default"]['checking__summary-headline']
      }, message);
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

Failed.defaultProps = {
  isOverBalance: false,
  commonErrors: []
};
var _default = Failed;
exports["default"] = _default;